import flatpickr from 'flatpickr'

export default {
  mounted() {
    flatpickr(this.el, {
      enableTime: true,
      altInput: true,
      altFormat: 'n/j/Y h:i K',
      dateFormat: 'Z',
    })
  },
}
